
import React from "react";
import { Helmet } from "react-helmet-async";

const AdminAgents: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Manage Agents - Admin Dashboard</title>
      </Helmet>
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Manage Agents</h1>
        <p className="text-muted-foreground">Agent management interface.</p>
      </div>
    </>
  );
};

export default AdminAgents;
